
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m3.62 15.163 22.37-9.994 2.391 5.353-2.375.686-.97 1.644-1.833.53-.97 1.643-1.833.53-.97 1.643-1.833.53-.97 1.644-1.842.533-.889 1.432-.644.064.255.57a1.751 1.751 0 0 1-.883 2.313s-4.417 1.948-4.58 1.97a1.758 1.758 0 0 1-1.84-1.019l-3.467-7.76a1.75 1.75 0 0 1 .883-2.312Zm4.283 9.587 4.109-1.836a.248.248 0 0 0 .148-.235.25.25 0 0 0-.022-.095l-3.467-7.76a.25.25 0 0 0-.329-.128l-.23.103-3.88 1.733a.249.249 0 0 0-.126.33l3.467 7.761a.25.25 0 0 0 .33.127Zm16.144-13.174.97-1.643 1.291-.374-1.076-2.408L9.92 13.99c.045.07.086.144.12.22l2.567 5.746.405-.04.802-1.293 1.825-.527.97-1.643 1.832-.53.97-1.644 1.833-.53.97-1.643 1.833-.53Zm-16.26 5.559-1.37.611a.25.25 0 0 0-.126.33l1.836 4.11a.25.25 0 0 0 .33.126l1.37-.612a.25.25 0 0 0 .126-.33L8.117 17.26a.25.25 0 0 0-.33-.126Z"}})])
          )
        }
      }
    